module.exports = __webpack_public_path__ + "static/ITUT28-054e0473554598711344393414b6f3fe.jpg";